import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=50539345&scoped=true&"
import script from "./Insurance.vue?vue&type=script&lang=js&"
export * from "./Insurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50539345",
  null
  
)

export default component.exports